export default __webpack_public_path__ + "static/media/030-narrow-road.1fe895b9.png";